export default "__VITE_ASSET__dc4c34be__"